// --------------------------------------------------------------------------
// #206 Membership Renewal Total
//     - Total donation amount including any additional donation
// --------------------------------------------------------------------------
// Author:      Zone
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2016, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;
    var $membershipAmount = context.find('[data-membership-amount]');
    var $monthlyAmount = context.find('[data-frequency="monthly"] [data-updated-donation]');
    var additionalAmount = context.find('[data-name="donation-input"]');
    var finalTotal = context.find('[data-updated-donation]').first();
    var renewalPaymentOptions = context.find('.renewal-payment-options');
    var paymentOptions = context.find('[data-name="renewal-payment-option"]');
    var creditCardForm = context.find('[data-name="credit-card"]');
    var directDebitForm = context.find('[data-name="direct-debit"]');
    var additionalDonationSection = context.find('.renewal-additional-donation').parent().parent();
    var $isAnnually = context.find('input[name="IsAnnually"]');
    var $isMonthly = context.find('input[name="IsMonthly"]');
    var showDirectDebit = false;
    var $currentPageUrl = context.find('input[name="CurrentPageUrl"]');
    var $renewalAmountConfirmation = context.find('[data-name="renewal-amount-confirmation"]');
    var $renewalConfirmationText = context.find('[data-name="renewal-amount-confirmation-text"]');
    var $renewalDonationText = context.find('[data-name="renewal-amount-confirmation-donation-text"]');
    var $renewalTotalText = context.find('[data-name="renewal-amount-confirmation-total-text"]');
    var $renewalAmount = context.find('[data-name="renewal-amount-confirmation-amount"]');
    var $renewalDonationAmount = context.find('[data-name="renewal-amount-confirmation-donation-amount"]');
    var $renewalTotalAmount = context.find('[data-name="renewal-amount-confirmation-total-amount"]');
    var confirmationText = $renewalAmountConfirmation.data('text-renewal-confirmation');
    var directDebitText = $renewalAmountConfirmation.data('text-renewal-direct-debit');
    var donationText = $renewalAmountConfirmation.data('text-renewal-donation');
    var perMonthText = $renewalAmountConfirmation.data('text-renewal-per-month');
    var perYearText = $renewalAmountConfirmation.data('text-renewal-per-year');
    var totalText = $renewalAmountConfirmation.data('text-renewal-total');

    function renderAdditionalAmount(showDirectDebit) {
        if (showDirectDebit) {
            creditCardForm.hide();
            additionalDonationSection.hide();

            // remove additional donation amount, so it's not POSTed to the backend
            additionalAmount.val('');

            directDebitForm.show();
        } else {
            creditCardForm.show();
            additionalDonationSection.show();

            directDebitForm.hide();
        }
    }

    function renderConfirmation(showDirectDebit, membershipAmount, monthlyAmount, donationAmount, totalAmount) {
        $renewalDonationText.html('');
        $renewalTotalText.html('');
        $renewalDonationAmount.html('');
        $renewalTotalAmount.html('');

        if (!showDirectDebit) {
            $renewalConfirmationText.html(confirmationText);
            $renewalAmount.html(membershipAmount);

            if (donationAmount > 0) {
                $renewalDonationAmount.html(donationAmount.toFixed(2));
                $renewalTotalAmount.html('&pound;' + totalAmount);
                $renewalDonationText.html(' ' + donationText);
                $renewalTotalText.html(totalText);
            }
        } else {
            $renewalConfirmationText.html(directDebitText);
            var frequencyText = perYearText;
            var frequencyAmount = membershipAmount;
            if ($isMonthly.val().toLowerCase() === 'true') {
                frequencyText = perMonthText;
                frequencyAmount = monthlyAmount;
            }
            $renewalAmount.html(frequencyAmount.toFixed(2) + ' ' + frequencyText);
        }
    }

    // gets the renewal + donation amounts, triggers HTML refresh and return the total amount to be pa
    function updateRenewalAmount() {
        var membershipAmountVal = parseFloat($membershipAmount.text());
        var monthlyAmountVal = parseFloat($monthlyAmount.text());
        var additionalAmountVal = additionalAmount.val() ? parseFloat(additionalAmount.val()) : 0;
        var combinedAmountVal = parseFloat(membershipAmountVal + additionalAmountVal).toFixed(2);

        renderConfirmation(showDirectDebit, membershipAmountVal, monthlyAmountVal, additionalAmountVal, combinedAmountVal);

        return combinedAmountVal;
    }

    /// update the form hidden fields
    function updateForm(amount) {
        var url = window.location.pathname;

        // Allow for missing trailing slash
        if (url.substr(-1) !== '/') {
            url += '/';
        }

        var form = context.find('form');
        var token = context.find('input[name="__RequestVerificationToken"]');
        var isMonthly = $isMonthly.val();

        renderAdditionalAmount(showDirectDebit);

        $.ajax({
            data: '&isMonthly=' + isMonthly + '&amount=' + amount + '&__RequestVerificationToken=' + token.val() + '&' + 'UpdateForm=',
            type: 'POST',
            url: url + 'updateform/',
            dataType: 'json',
            success: function success(data) {
                var type = typeof data === 'undefined' ? 'undefined' : _typeof(data);
                if (showDirectDebit) {
                    form.attr('action', $currentPageUrl.val());
                } else {
                    if (type === 'object' && data.result === 'OperationSuccessful') {
                        /// Clear the form
                        form.find('input[name="x_fp_hash"], input[name="x_fp_sequence"], input[name="x_fp_timestamp"], input[name="x_login"], input[name="x_amount"], input[name="x_relay_url"], input[name="x_relay_response"], input[name="SourceCode"]').remove();

                        var ccformhtml = $.parseHTML(data.ccform);
                        form.append(ccformhtml);
                        form.attr('action', data.authorizeurl);
                    }
                }
            }
        });
    }

    function init() {
        // move the additional amount block into the payment block
        additionalDonationSection.insertAfter(renewalPaymentOptions);
        // refresh the jQuery handle for the element
        additionalDonationSection = context.find('.renewal-additional-donation');
        // hide additional amount block if the direct debit form is not active
        showDirectDebit = directDebitForm.is(':visible');
        renderAdditionalAmount(showDirectDebit);
        updateRenewalAmount();

        additionalAmount.on('keyup', function () {
            updateForm(updateRenewalAmount());
        });

        paymentOptions.on('click', function (e) {
            var clickedOption = $(e.target).closest('[data-name="renewal-payment-option"]');
            // set visuals
            paymentOptions.addClass('renewal-payment-options__confirmation-wrapper--unselected');
            clickedOption.removeClass('renewal-payment-options__confirmation-wrapper--unselected').addClass('renewal-payment-options__confirmation-wrapper');
            finalTotal = clickedOption.find('[data-updated-donation]');

            // post back hidden input fields
            var frequency = clickedOption.data('frequency');
            $isMonthly.val(frequency === 'monthly');
            $isAnnually.val(frequency === 'annually');

            showDirectDebit = clickedOption.data('direct-debit');

            updateForm(updateRenewalAmount());
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/membership-renewal-total.js
// module id = 267
// module chunks = 0